import { createAction } from 'redux-actions';
import * as types from '../constants/actionTypes/columnItem';

export const updateColumnItemContent = createAction(types.UPDATE_COLUMN_ITEM_CONTENT);
export const refreshColumnItemContent = createAction(types.REFRESH_COLUMN_ITEM_CONTENT);
export const addNewItemFromPlaceholderToColumn = createAction(types.ADD_NEW_ITEM_FROM_PLACEHOLDER_TO_COLUMN);
export const moveColumnItemContentToAnotherColumn = createAction(types.MOVE_COLUMN_ITEM_CONTENT_TO_ANOTHER_COLUMN);
export const duplicateColumnItem = createAction(types.DUPLICATE_COLUMN_ITEM);
export const deleteColumnItem = createAction(types.DELETE_COLUMN_ITEM);
export const addNewColumnItem = createAction(types.ADD_NEW_COLUMN_ITEM);
export const updateColumnItemContentInMultipleBlocks = createAction(types.UPDATE_COLUMN_ITEM_CONTENT_IN_MULTIPLE_BLOCKS);
export const updateColumnItemFontInMultipleBlocks = createAction(types.UPDATE_COLUMN_ITEM_FONT_IN_MULTIPLE_BLOCKS);
export const overrideColumnItem = createAction(types.OVERRIDE_COLUMN_ITEM);
